import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { VendorService } from '../_services/vendor.service';

@Injectable({
  providedIn: 'root'
})
export class VendorsResolverService {
  private readonly vendorService = inject(VendorService);

  resolve(): Observable<Array<string>> | any {
    // this.vendorService.loadVendors();

    return this.vendorService.vendors;
  }
}
